/* @flow */

import * as React from 'react';
import { withRouter } from 'react-router-dom';
import colorUtils from 'color';
import { get } from 'lodash/fp';
import { hover } from 'app/utils/cssUtils';
import useSheet from 'app/jss';
import StatusDot from 'app/components/commons/StatusDot';
import Pill from 'app/components/commons/Pill';
import Icon from 'app/components/commons/Icon';
import LivePill from 'app/components/styled/LivePill';
import NavPrimaryLink from './NavPrimaryLink';

type Props = {
  children: any,
  classes: Object,
  external?: boolean,
  icon: string,
  isLive?: boolean,
  isFree?: boolean,
  isMarked?: boolean,
  isBeta?: boolean,
  isNew?: boolean,
  location: Object,
  url: string
};

const defaultProps = {
  external: false,
  isBeta: false,
  isFree: false,
  isLive: false,
  isMarked: false,
  isNew: false
};

class NavPrimaryRow extends React.PureComponent {
  props: Props;

  render() {
    const {
      children,
      classes,
      external,
      icon,
      isBeta,
      isFree,
      isLive,
      isMarked,
      isNew,
      location,
      url
    } = this.props;
    return (
      <div className={classes.primaryNavRow}>
        <NavPrimaryLink
          external={external}
          url={url}
          activeClassName={classes.primaryNavItem__Active}
          className={classes.primaryNavItem}
          location={{
            pathname: get('state.referrer', location) || location.pathname
          }}
        >
          <div className={classes.icon}>
            <Icon type={icon} />
          </div>
          <span className={classes.primaryNavItem_Title}>{children}</span>
          {isNew && <Pill className={classes.newPill} label="NEW" />}
          {isBeta && <Pill className={classes.newPill} label="BETA" kind="success" />}
          {isFree && <Pill className={classes.newPill} label="FREE" kind="success" />}
          {isMarked && <StatusDot />}
          {isLive && <LivePill />}
        </NavPrimaryLink>
      </div>
    );
  }
}

NavPrimaryRow.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    primaryNavRow: {
      borderColor: theme.color.basis3,
      borderTopWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      borderLeftWidth: 0,
      borderStyle: 'solid',
      position: 'relative',
      '&:last-child': {
        borderBottomWidth: 1
      }
    },
    primaryNavItem: {
      alignItems: 'center',
      borderLeft: '3px solid transparent',
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing.small,
      transition: 'all 0.2s',
      ...hover({
        backgroundColor: colorUtils(theme.color.basis1)
          .lighten(0.4)
          .hex(),
        cursor: 'default',
        textDecoration: 'none'
      }),
      '&:active, &:focus': {
        textDecoration: 'none'
      }
    },
    primaryNavItem__Active: {
      borderLeftColor: theme.color.primary,
      color: theme.color.primary
    },
    primaryNavItem_Title: {
      flexGrow: 1,
      fontSize: theme.fontSize.xsmall,
      fontWeight: theme.fontWeight.demiBold,
      paddingTop: 2
    },
    newPill: {
      lineHeight: 1.3,
      padding: [2, 4, 0, 4]
    },
    icon: {
      width: 20,
      height: 20,
      paddingRight: 5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
}

export default useSheet(applyStyles)(withRouter(NavPrimaryRow));
